// extracted by mini-css-extract-plugin
export default {"root":"IconOpenFolder_root__tvfBf","openFolder":"IconOpenFolder_openFolder__in7hv","warning":"IconOpenFolder_warning__U6Qer","error":"IconOpenFolder_error__G4ELQ"};